import script from "./Desktop.vue?vue&type=script&setup=true&lang=js"
export * from "./Desktop.vue?vue&type=script&setup=true&lang=js"

import "./Desktop.vue?vue&type=style&index=0&id=585f03bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585f03bc"]])

export default __exports__